import z from 'zod'

export const BankDetailsSchema = z.object({
    accountName: z.string().default(''),
    bsb: z.string().default(''),
    accountNumber: z.string().default(''),
})

export type BankDetailsSchema = z.infer<typeof BankDetailsSchema>
